import { I18n } from '@aws-amplify/core';
import * as S from './styles';

interface FeatureStateTagProps {
	feat_state: string;
}

export function FeatureStateTag({ feat_state }: Readonly<FeatureStateTagProps>) {
	return (
		<S.FeatureStateTagContainer>
			<S.FeatureStateTagText language={navigator.language}>{I18n.get(feat_state)}</S.FeatureStateTagText>
		</S.FeatureStateTagContainer>
	);
}
